module.exports = __webpack_public_path__ + "static/media/logo.38b250e2.png";